<template>
    <v-data-table
        dense
        :headers="headers"
        :items="itemMeasureUnits"
        :loading="loading"
        hide-default-footer
        disable-pagination
        disable-sort
    >
    <template v-slot:[`item.actions`]="{item}">
        <v-btn icon color="primary" @click="handleRowClick(item)">
            <v-icon>mdi-pencil</v-icon>
        </v-btn>
    </template>
    <template v-slot:[`item.conversion`]="{item}">
        <span>{{ item.conversion }} </span> <span class="grey--text"> {{ data ? data.measure_unit.name : null }} </span>
    </template>

    </v-data-table>
</template>

<script>
export default {
    name: "ItemMeasureUnitList",
    props: {
        data: Object,
        loading: Boolean
    },
    data() {
        return {
            headers: [
                { text: "Measure Unit Name", value: "name"},
                { text: "Conversion ", value: "conversion"},
                { text: "", value: "actions" }
            ]
        }
    },
    computed: {
        itemMeasureUnits() {
            if(!this.data) return [];
            return this.data.measure_units.filter(each => each.conversion != 1);
        }
    },
    methods: {
        handleRowClick(measureUnit) {
            this.$router.push({ name: "ItemMeasureUnitEdit", params: { id: this.data.id, unitId: measureUnit.id }})
        }
    }
}
</script>

<style>
</style>